import { TravellerFieldEnum } from '@websky/graphql';
import { validateDate } from '../../../Passenger/utils';
import { FormValues } from '../../types';
import { SubsidiesInfoByPassengers } from './reducers';
import { convertGenderToCorrectValue } from '../../../utils';

export const checkValue = (allValues: any, name: string, value: string) => {
	if (name === 'gender') {
		return convertGenderToCorrectValue(allValues[name]) === convertGenderToCorrectValue(value);
	}

	return allValues[name] === value;
};

export const isSubsidyValidForPassenger = (
	passengerValues: FormValues['passengers'][0],
	subsidy: SubsidiesInfoByPassengers,
	ignoreFields: TravellerFieldEnum[] = []
): boolean => {
	return subsidy.validation
		.filter(validation => {
			if (!ignoreFields.length) {
				return true;
			}

			return !ignoreFields.includes(validation.type);
		})
		.every(validation => {
			const value = passengerValues[validation.name];

			const validationResult = validation.validationRules.some(rules => {
				if (rules.with?.every(cond => checkValue(passengerValues, cond.name, cond.value))) {
					if (validation.type === TravellerFieldEnum.BirthDate) {
						if (!value) {
							return false;
						}

						return typeof validateDate(value as string, rules) !== 'string';
					}

					if (rules.options?.length) {
						return rules.options.some(option => checkValue(passengerValues, validation.name, option.value));
					}
				}

				if (rules.options?.length) {
					return rules.options.some(option => checkValue(passengerValues, validation.name, option.value));
				}

				return false;
			});

			return validationResult;
		});
};
